'use strict';

export default {
    init() {
        this.prepare_listeners();
    },

    prepare_listeners() {
        $('.overlay-close, .btn-close').on('click', event => {
            event.preventDefault();
            this.close_overlay();
        });

        $('.overlay').on('click', event => {
            if ($(event.target).closest('.overlay-content, .video-holder').length === 0) {
                this.close_overlay();
            }
        });
    },

    show_overlay() {
        $('.overlay').show();
        //todo vyresit pridani classy na body at pomoci ni vycentrujeme objekt popUp na center.
        //$('body').scrollTop(0);  //prozatim resim scrollem top;
    },

    close_overlay() {
        $('.overlay').hide();
        $('.video-holder').remove();
        //$('body').removeClass("togglePopUpOpen");
    }
};



// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/overlay.js